(() => {
  if (window.NeonHubCartAddOnsInitialized) return;
  window.NeonHubCartAddOnsInitialized = true;

  const bundleLine = target => {
    const directLine = target.closest?.('line-item[data-neonhub-bundle]');
    if (directLine) return directLine;

    let lineKey = target.dataset?.lineKey;
    if (!lineKey && target instanceof HTMLAnchorElement && target.href.includes('/cart/change')) {
      lineKey = new URL(target.href).searchParams.get('id');
    }
    if (!lineKey) return null;
    return document.querySelector(`line-item[data-line-key="${CSS.escape(lineKey)}"][data-neonhub-bundle]`);
  };

  const setLineBusy = (line, busy) => {
    if (!line) return;
    line.toggleAttribute('aria-busy', busy);
    line.querySelectorAll('input, button, a').forEach(control => {
      if ('disabled' in control) control.disabled = busy;
    });
  };

  const showError = (line, message) => {
    line?.querySelector('[role="alert"]')?.remove();
    const info = line?.querySelector('.line-item__info');
    if (!info) return;

    const error = document.createElement('p');
    error.className = 'text-error text-xs';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    info.append(error);
  };

  const updateLines = async (sourceLine, updates) => {
    const affectedLines = Object.keys(updates)
      .map(key => document.querySelector(`line-item[data-line-key="${CSS.escape(key)}"]`))
      .filter(Boolean);
    affectedLines.forEach(line => setLineBusy(line, true));

    let sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections },
    }));
    sections = Array.from(new Set(sections));

    try {
      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const cart = await response.json();

      if (!response.ok) {
        throw new Error(cart.description || 'Your configured add-ons could not be updated.');
      }

      if (window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'line-item:change',
          cart,
        },
      }));
    } catch (error) {
      showError(sourceLine, error.message || 'Your configured add-ons could not be updated.');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      affectedLines.forEach(line => setLineBusy(line, false));
    }
  };

  const synchronizeBundle = (sourceLine, quantity) => {
    const bundleId = sourceLine.dataset.neonhubBundle;
    if (!bundleId) return;

    const updates = {};
    document.querySelectorAll('line-item[data-neonhub-bundle]').forEach(line => {
      if (line.dataset.neonhubBundle !== bundleId) return;
      updates[line.dataset.lineKey] = quantity;
    });

    updateLines(sourceLine, updates);
  };

  const handleQuantityChange = event => {
    const input = event.currentTarget;
    const line = bundleLine(input);
    if (!line || line.dataset.neonhubAddon === 'true') return;

    event.preventDefault();
    event.stopPropagation();
    synchronizeBundle(line, Math.max(0, Number(input.value || 0)));
  };

  const quantitySelector = 'input.quantity-input[data-line-key]';

  const bindQuantityInputs = root => {
    const inputs = [];
    if (root instanceof Element && root.matches(quantitySelector)) inputs.push(root);
    root.querySelectorAll?.(quantitySelector).forEach(input => inputs.push(input));

    inputs.forEach(input => {
      const line = bundleLine(input);
      if (!line || line.dataset.neonhubAddon === 'true') return;
      if (input.dataset.neonhubBundleQuantityBound === 'true') return;
      input.dataset.neonhubBundleQuantityBound = 'true';
      input.addEventListener('change', handleQuantityChange, true);
    });
  };

  bindQuantityInputs(document);

  new MutationObserver(records => {
    records.forEach(record => {
      record.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) bindQuantityInputs(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const addonRemove = event.target.closest('[data-neonhub-remove-addon]');
    if (addonRemove) {
      const line = bundleLine(addonRemove);
      if (!line) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      updateLines(line, { [line.dataset.lineKey]: 0 });
      return;
    }

    const removeLink = event.target.closest('a[href*="/cart/change"]');
    const line = removeLink ? bundleLine(removeLink) : null;
    if (!line || line.dataset.neonhubAddon === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    synchronizeBundle(line, 0);
  }, true);
})();
